
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perf/[id]",
      function () {
        return require("private-next-pages/perf/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perf/[id]"])
      });
    }
  